import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Accueil", href: "/" },
  { label: "À propos", href: "/a-propos" },
  { label: "Contact", href: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";
  const isTransparent = isHome && !scrolled;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isTransparent
          ? "bg-transparent"
          : "bg-white border-b border-gray-100"
      }`}
    >
      <div className="flex items-center justify-between px-8 lg:px-16 h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/be183dea-b8b4-4fc4-b8c3-703c3fe9bf21.png"
            alt="MARCINSKI Logo"
            className="h-10 w-auto object-contain"
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center gap-10">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`font-sans text-sm tracking-widest uppercase transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                isTransparent
                  ? "text-white/80 hover:text-white"
                  : "text-brand-gris hover:text-brand-noir"
              } ${location.pathname === link.href ? (isTransparent ? "text-white" : "text-brand-noir") : ""}`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className={`px-6 py-2.5 font-sans text-sm tracking-widest uppercase transition-all duration-300 cursor-pointer whitespace-nowrap ${
              isTransparent
                ? "border border-white/60 text-white hover:bg-white hover:text-brand-noir"
                : "border border-brand-noir text-brand-noir hover:bg-brand-noir hover:text-white"
            }`}
          >
            Projet
          </Link>
        </nav>

        {/* Mobile menu button */}
        <button
          className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${isTransparent ? "text-white" : "text-brand-noir"}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden bg-white border-t border-gray-100 transition-all duration-300 overflow-hidden ${
          menuOpen ? "max-h-96" : "max-h-0"
        }`}
      >
        <nav className="flex flex-col px-8 py-6 gap-5">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="font-sans text-sm tracking-widest uppercase text-brand-gris hover:text-brand-noir transition-colors cursor-pointer"
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
}
